/* eslint-disable no-console */
const PREFIX = '[sd-embedder]'

export const debug = console.debug.bind(window.console, PREFIX)
export const warn = console.warn.bind(window.console, PREFIX)
export const error = console.error.bind(window.console, PREFIX)
export const log = console.error.bind(window.console, PREFIX)

export interface Logger {
  debug: typeof debug
  warn: typeof warn
  error: typeof error
  log: typeof log
  child (name: string): Logger
}

export const logger: Logger = {
  debug,
  warn,
  error,
  log,
  child (name: string): Logger {
    const child: Partial<Logger> = {}
    Object.entries(this).forEach(([key, value]) => {
      if (typeof value === 'function') {
        child[key] = value.bind(value, `[${name}]`)
      }
    })

    return child as Logger
  }
}
